import { ACCOUNT_TYPE } from "../constants/types.lib";

export function normalizeAccountType(
  accountType: string | null | undefined,
): "buyer" | "vendor" | "freight_carrier" | undefined {
  if (accountType === ACCOUNT_TYPE.BUYER) return ACCOUNT_TYPE.BUYER;
  if (accountType === ACCOUNT_TYPE.VENDOR) return ACCOUNT_TYPE.VENDOR;
  if (accountType === ACCOUNT_TYPE.FREIGHT_CARRIER)
    return ACCOUNT_TYPE.FREIGHT_CARRIER;
  if (accountType === "both") return ACCOUNT_TYPE.VENDOR;
  return undefined;
}
